<template>
  <div>
    <component
      v-if="isLoaded && !!route.name"
      :key="layout"
      :is="route.meta.layout || layout"
    >
      <router-view />
      <user-tracker />
    </component>

    <NotificationsDispatcher/>
    <PurchaseOptionsModal/>
    <ServiceNudgeModal/>
    <FabBtn />
    <AuthPopup/>
    <div id="modals-container"></div>
    <div id="tooltips-container"></div>
    <div id="menus-container"></div>
  </div>
</template>

<script setup>
import {
    isSubscriptionModelActivated,
} from './utils/helpers'

import defaultLayout from './layouts/default'

import ServiceNudgeModal from './modals/services-nudges/service-nudge-modal.vue'
import PurchaseOptionsModal from "./modals/premium-plans-modal.vue"

import UserTracker from './components/user-tracker.vue'
import NotificationsDispatcher from "./components/notifications/notifications-dispatcher.vue"
import AuthPopup from "./components/auth/auth-popup.vue"

import { setAuthState } from './composables/auth'
import { useTokens } from './store/token.store'
import { usePremiumNudgeStore } from "./store/nudge-premium.store";
import { update as updateProfile } from "./api/profile"

import axios from './utils/axios'
import { ref, watch, onMounted, shallowRef } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter, useRoute } from 'vue-router'

import FabBtn from './components/fab-btn'

import { markAsAbandonedCard } from './api/profile'

const router = useRouter()
const route = useRoute()

const premiumNudgeStore = usePremiumNudgeStore();

const { isAuthenticated, setUser, getUser } = setAuthState()
const isLoaded = ref(!isAuthenticated())

const saveUTMParamsToLocalStorage = (queryParams) => {
  const utmParams = ['utm_medium', 'utm_source', 'utm_campaign', 'utm_content', 'utm_term'];

  // Check if any UTM params exist in the query
  utmParams.forEach(param => {
    if (queryParams[param]) {
      localStorage.setItem(param, queryParams[param]);
    }
  });
}

watch(() => route.name, () => {
  window.dataLayer = window.dataLayer || []; 
  window.dataLayer.push({'user_id': getUser()?.id });
}, { immediate: true })

watch(() => route.query, () => {
    saveUTMParamsToLocalStorage(route.query)
}, { immediate: true })

const layout = shallowRef(defaultLayout)

if(! isSubscriptionModelActivated()) {
  const tokenStore = useTokens()
  const { hasNoTokens } = storeToRefs(tokenStore)

  watch(hasNoTokens, (hasNoTokensNewValue) => {
    if(hasNoTokensNewValue) {
      markAsAbandonedCard(true)
    }
  })
}

watch(route, async () => {
    if (getUser()?.options?.show_premium_nudge === true) {
        premiumNudgeStore.setShowModal(async () => {
            const onboardingBody = {
                ...getUser()?.options,
                show_premium_nudge: false
            }

            const user = await updateProfile({ options: onboardingBody });
            setUser(user.data.data)
        });
    }
})

onMounted(() => { 
  // first time check if cookie is not expired, if expired user gets redirected to login page
  if (isAuthenticated()) {
    axios.get('/api/user').then((res) => {
      setUser(res?.data?.data)
      
      let urlParams = window.location.search
        .slice(1)
        .split('&')
        .map(p => p.split('='))
        .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});

      const lastUsedPage = localStorage.getItem('currentPage')

      if(lastUsedPage) {
        router.push({
          path: lastUsedPage,
          query: urlParams
        })
      }

      isLoaded.value = true
    })
  }
})
</script>
